import { isNullOrUndefined } from '../../util/helpers';
var Wind = /** @class */ (function () {
    function Wind() {
    }
    Object.defineProperty(Wind.prototype, "calm", {
        /**
         * Returns true if the winds are calm
         * @returns {boolean}
         */
        get: function () {
            return !this.direction && (!this.speed || this.speed === '0') && (!this.gust || this.gust === '0');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Wind.prototype, "vrb", {
        /**
         * Returns true if the wind direction is variable
         * @returns {boolean}
         */
        get: function () {
            return !this.calm && this.direction === 0;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parse wind data as returned by API into an instance of the Wind type
     * @param direction
     * @param speed
     * @param gust
     * @returns {Wind}
     */
    Wind.parse = function (direction, speed, gust) {
        if ([direction, speed, gust].every(isNullOrUndefined)) {
            return null;
        }
        return Object.assign(new Wind(), {
            direction: direction,
            speed: speed,
            gust: gust
        });
    };
    return Wind;
}());
export { Wind };
